












import Vue from 'vue'
import helpers from '@/helpers'
import KisweStudioLogo from '@/components/Kiswe/KisweStudioLogo'

export default Vue.extend({
  name: 'NoTeamMessage',
  props: {
    showLogout: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    logout () {
      this.$store.direct.dispatch.user.logoutUser()
    },
    getURL (name, params) {
      return helpers.getURL(this.$router, name, params)
    }
  },
  components: {
    KisweStudioLogo
  }
})
